<template>
  <div class="root-chart">
    <ul>
      <li v-for="objtype in objtypeList" :style="{ width: objtype.calcWidth + '%' }" :class="{ active: objtype.isActive }" :key="objtype.objtypeId" @click="changeActivePage(objtype)">
        <span>{{ getObjtypeName(objtype.objtypeId) }}</span>
        <span class="status">{{ objtype.count }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import clone from 'lodash/clone';
import { mapGetters } from 'vuex';
import { VMS_OBJTYPE } from '@/constants/objdefine';
import perfApi from '@/api/virtual/performance/common';

export default {
  name: 'WObjtypeBar',
  props: {
    active: {
      type: Boolean,
      defulat: () => false,
    },
  },
  data() {
    return {
      objtypeList: [],
    };
  },
  computed: mapGetters(['selectedNode', 'selectedVmsObjtypeIds']),
  watch: {
    selectedNode: {
      handler() {
        this.loadData();
      },
      immediate: true,
    },
    active: {
      handler() {
        this.loadData();
      },
    },
  },
  methods: {
    loadData() {
      if (this.active) {
        const treeType = this.$route.path.indexOf('physical') > 0 ? 'physical' : 'logical';
        const params = {
          treeType,
          subType: this.selectedNode.subType,
          managetypeId: this.selectedNode.managetypeId,
          objId: this.selectedNode.obj ? this.selectedNode.obj.objId : null,
          hypervisorType: this.selectedNode.hypervisorType,
          virtualcenterGroupId: this.selectedNode.virtualcenterGroupId,
          objtypeId: this.selectedNode.obj ? this.selectedNode.obj.objtypeId : this.selectedNode.objtypeId,
        };
        perfApi.getObjCountForObjtype(params).then((response) => {
          if (response.data.success) {
            const tempList = response.data.data;
            const tempSelectedList = [];
            tempList.forEach((items) => {
              if (this.selectedVmsObjtypeIds.indexOf(items.objtypeId) > -1) {
                items.isActive = true;
                tempSelectedList.push(items.objtypeId);
              }
            });
            this.objtypeList = tempList;
            this.$store.dispatch('setVmsObjtypeIds', tempSelectedList);
          }
        });
      }
    },
    /**
     * 해당 objtypeId에 대한 Name을 반환
     * @author kimjy
     * @param  {String} objtypeId
     * @return {String} objtypeName
     */
    getObjtypeName(objtypeId) {
      return VMS_OBJTYPE[objtypeId];
    },
    /**
     * 상단 Objtype 선택이 변경된 경우
     * @author kimjy
     * @param  {Object} objtype 선택/해제된 장비의 정보
     */
    changeActivePage(objtype) {
      objtype.isActive = !objtype.isActive;
      const tempSelectedList = clone(this.selectedVmsObjtypeIds);
      if (objtype.isActive) {
        tempSelectedList.push(objtype.objtypeId);
      } else {
        tempSelectedList.splice(tempSelectedList.indexOf(objtype.objtypeId), 1);
      }
      this.$store.dispatch('setVmsObjtypeIds', tempSelectedList);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/virtual/performance/group/components/ObjtypeBar.vue